export default "__VITE_ASSET__BIOhtiYw__"